// Related to Giphy API.
// This could be reused on the BE.

import * as t from 'io-ts';

import {makeApiType, makeEnumRuntimeType} from './apiTypes';

/*
 * Runtime type.
 */

const RGiphyPaginationDirty = t.type({
  offset: t.number,
  total_count: t.number,
  count: t.number,
});

const RGiphyImageDirty = t.type({
  url: t.string,
  width: t.number,
  height: t.number,
  size: t.number,
});

// See https://developers.giphy.com/docs/api/schema#image-object
// and https://developers.giphy.com/docs/optional-settings#rendition-guide.
// This should match the renditions that the backend offers through the Gif resource.
export enum GiphyRenditionsEnum {
  FIXED_WIDTH = 'fixed_width',
  DOWNSIZED = 'downsized',
}

const RGiphyImagesDirty = t.record(makeEnumRuntimeType(GiphyRenditionsEnum), RGiphyImageDirty);

const RGifDirty = t.type({
  id: t.string,
  title: t.string,
  images: RGiphyImagesDirty,
});

const RGifResultsDirty = t.type({
  pagination: RGiphyPaginationDirty,
  data: t.readonlyArray(RGifDirty),
});

/*
 * Type.
 */

export interface GifModel extends t.TypeOf<typeof RGifDirty> {}
export interface GifResults extends t.TypeOf<typeof RGifResultsDirty> {}

/*
 * API type.
 */

export const ApiGif = makeApiType('gif', RGifResultsDirty, (g) => g);
